import styled from '@emotion/styled';
import { useEffect } from 'react';
import { Alert } from 'antd';
import { useTranslate } from '@tolgee/react';
import posthog from '@leyan/lytics';
import Review from './Review';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  overflow: hidden;
`;

const Content = styled(Review)`
  flex: 1 0 0;
  border-top: solid 1px #e1e4ea;
`;

const StyledAlert = styled(Alert)`
  background: #f0f4ff;
  &-icon {
    color: #f2a100;
  }
`;

let bannerVisible = true;

function Entry() {
  const { t } = useTranslate();

  useEffect(() => {
    posthog.capture('$review', {
      type: 'entryPage',
    });
  }, []);

  return (
    <Container>
      {bannerVisible ? (
        <StyledAlert
          banner
          type="info"
          message={t('scene.reviewWorkspace.list.hint.dailyReminder')}
          closable
          onClose={() => {
            bannerVisible = false;
          }}
        />
      ) : null}
      <Content />
    </Container>
  );
}

export default Entry;
